import { render, staticRenderFns } from "./Userinfo.vue?vue&type=template&id=f32c78fc&"
import script from "./Userinfo.vue?vue&type=script&lang=js&"
export * from "./Userinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports